<template>
  <p
    v-if="averagePrice != null"
    class="title is-6 has-text-dark mb-0"
  >
    Average price of filtered listings: £{{ formattedPrice }}
  </p>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SimilarListingsAveragePrice',
  computed: {
    ...mapGetters('companion/similarListings', ['averagePrice', 'total']),
    formattedPrice() {
      return Math.round(this.averagePrice).toLocaleString()
    }
  }
}
</script>